<template>
  <div class="side_box">
    <div>
      <label for="ref">REF</label>
      <span>{{this.item.ref}}</span>
      <!-- <span v-if="this.item">{{this.item.ref}}</span>
      <span v-else>...</span> -->
    </div>
    <div>
      <label for="type">Type</label>
      <span v-if="this.item">{{this.item.type}}</span>
      <span v-else>...</span>
    </div>
    <div v-if="this.item.type != 'assembly'">
      <label for="rawmat">Raw Material</label>
      <span v-if="this.item">{{this.item.rawMaterialName}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="flow">Production Flow</label>
      <span v-if="this.item">{{this.item.flowname}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="description">Description</label>
      <span v-if="this.item">{{this.item.description}}</span>
      <span v-else>...</span>
    </div>
    <!-- <div v-if="this.item.type == 'assembly'">
      <label for="subparts">List of Subparts</label>
      <table v-if="this.item.subparts.length > 0"> class="ref_box edit" v-if="!isEditing">
        <thead>
          <tr>
            <td></td>
            <td>REF</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="(subpart, index) in this.item.subparts" 
            :key="index"
          >
            <td>{{subpart.amount}}x</td>
            <td>{{subpart.name}}</td>
            <td>
              <i class="icon icon-error fas fa-times-circle"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div> -->
  </div>
</template>

<script>
export default {
  computed: {
  },
  props: {
    item: Object
  },
   mounted() {
  },
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";

.side_box {
  max-height: 440px;
}
</style>
